import React, { Component, createElement, Fragment } from 'react';
import { connect } from 'react-redux';
import builder, { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { actions, services } from '@comall-backend-builder/core';
import { get } from 'lodash';
import { message as AntMessage, Spin as AntSpin } from 'antd';

import { errorHandle } from '../../services';

const api = services.api;

interface liveRoomAddProductProps {
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

interface liveRoomAddProductStates {
    /**
     * 加载中
     */
    loading: boolean;
}

class liveRoomAddProduct extends Component<liveRoomAddProductProps, liveRoomAddProductStates> {
    constructor(props: liveRoomAddProductProps) {
        super(props);
        this.onAddBatch = this.onAddBatch.bind(this);
        this.state = {
            loading: false
        };
    }

    onAddBatch() {
        const { params: { roomid }, selectedRowKeys, entity, componentId } = this.props;
        const ids = selectedRowKeys.join(',');

        if (!ids) {
            AntMessage.error('请选择商品');
            return;
        }

        this.setState({ loading: true });

        api.post(
            { ids },
            { apiPath: `/live/room/import/${roomid}` }
        ).then(() => {
            // 加载完成
            this.setState({ loading: false });

            // 提示
            AntMessage.success('导入成功');

            // 重置table及筛选
            builder.getStore().dispatch(actions.tableRowSelectionChangeAction(componentId + '-Table', []));
            builder.getStore().dispatch(actions.filtersChangeAction(entity, { skuList: '' }));

            // 列表数据刷新
            entity.search({
                status: 'APPROVED',
                page: 1,
            });
        })
        .catch(errorHandle)
        .finally(() => {
            // 加载完成
            this.setState({ loading: false });
        });
    }

    renderBtn() {
        const flexLayoutProps = {
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'Button',
                    text: '批量导入',
                    type: 'primary',
                    onClick: this.onAddBatch,
                    style: {
                        flexGrow: 0
                    },
                }
            ]
        };
        return createElement(ComponentsManager.get('FlexLayout'), flexLayoutProps);
    }

    renderTable() {
        const { entity, componentId, params: { roomid } } = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            rowKey: 'id',
            rowSelection: {
                onChange() {},
            },
            loadFirstPage: true,
            pagination: {
                showQuickJumper: true,
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true
            },
            columns: [
                {
                    property: 'skuId',
                },
                {
                    property: 'skuCode',
                },
                {
                    property: 'name',
                },
                {
                    property: 'imgUrl',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
            ],
            actionColumn: {
                title: '操作',
                width: 120,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'component',
                        component: 'LiveRoomAddProductBtn',
                        config: {
                            roomid
                        }
                    }
                ],
            }
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    render() {
        const { loading } = this.state;
        return (
            <AntSpin spinning={loading}>
                {this.renderBtn()}
                {this.renderTable()}
            </AntSpin>
        );
    }
}

function mapStateTopProps(state: any, props: any) {
    const { componentId } = props;
    const component = state.components[componentId + '-Table'];
    const componentState = {
        selectedRowKeys: get(component, 'selectedRowKeys') || [],
    };
    return componentState;
}

export const LiveRoomAddProduct = connect(mapStateTopProps)(liveRoomAddProduct);
